import * as types from './mutation-types'

export const createCodePromo = ({ commit, dispatch, state }, data) => {
  return new Promise((resolve, reject) => {
    axios.post('store/codePromo', data).then((response) => {
      resolve(response)
      console.log('response',response)
        commit(types.ADD_CODEPROMO, response.data.codepromo)
    }).catch((err) => {
      reject(err)
    })
  })
}


export const loadCodePromoStatus = ({commit, dispatch, state}) => {
  return new Promise((resolve, eject) => {
      window.axios.get('get/codePromo/status').then((response) => {
        resolve(response)
        commit(types.SET_CODE_PROMO_STATUS, response.data)
      }).catch((err) => {
          eject(err)
      })
  })
}

export const getTypeDiscount = ({commit, dispatch, state}) => {
  return new Promise((resolve, eject) => {
      window.axios.get('get/type/discount').then((response) => {
        console.log(response)
        resolve(response)
       commit(types.LOAD_DISCOUNT_TYPES, response.data)
      }).catch((err) => {
          eject(err)
      })
  })
}

// Page de détail : réglages, chiffres d'utilisation, commandes et clients
// pages : { orders_page, customers_page } (tableaux paginés côté serveur)
export const getCodePromoDetail = ({ commit, dispatch, state }, { id, pages }) => {
  return new Promise((resolve, reject) => {
    axios.get('show/codePromo/' + id + '/detail', { params: pages || {} }).then((response) => {
      resolve(response)
    }).catch((err) => {
      reject(err)
    })
  })
}

export const changeCodePromoStatus = ({ commit, dispatch, state }, data) => {
  return new Promise((resolve, reject) => {
    axios.patch('update/codePromo/' + data.id + '/status', { status: data.status }).then((response) => {
      resolve(response)
    }).catch((err) => {
      reject(err)
    })
  })
}

export const updateCodePromo = ({ commit, dispatch, state }, data) => {
  return new Promise((resolve, reject) => {
    axios.patch('update/codePromo/'+data.id, data).then((response) => {
      resolve(response)
    }).catch((err) => {
      reject(err)
    })
  })
}

export const getCodePromo = ({commit, dispatch, state},id) => {
  return new Promise((resolve, eject) => {
      window.axios.get('show/codePromo/'+id).then((response) => {
        resolve(response.data)
       // commit(types.SET_CODEPROMOSTATUS, response.data.codepromo_status)
      }).catch((err) => {
          eject(err)
      })
  })
}
export const deleteCodePromo = ({ commit, dispatch, state }, id) => {
  return new Promise((resolve, reject) => {
    axios.delete('delete/codePromo/'+id).then((response) => {
      resolve(response)
    }).catch((err) => {
      reject(err)
    })
  })
}
